import { render, staticRenderFns } from "./CheckoutRecertification.vue?vue&type=template&id=c3f08120"
import script from "./CheckoutRecertification.vue?vue&type=script&lang=ts"
export * from "./CheckoutRecertification.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports